<template>
    <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
            <v-card>

                <v-toolbar dense color="primary" app :clipped-left="true" dark tabs>
                    <v-btn icon @click="goBack()">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-toolbar-title>Eventos</v-toolbar-title>
                    <v-spacer/>
                </v-toolbar>

                <v-list two-line>
                    <v-subheader >EVENTOS</v-subheader>
                    <template v-for="(item) in items">
                        <div :key="item.id_transmissao">
                            <v-divider />
                            <v-list-tile avatar>
                                <v-list-tile-avatar>
                                    <img v-if="item.evento === 'DESARMED'" :src="'img/eventos/ic_disarmed.png'">
                                    <img v-if="item.evento === 'ARMED' || item.evento === 'ARMED-OUT'" :src="'img/eventos/ic_armed.png'">
                                    <img v-if="item.evento === 'BATTERY'" :src="'img/eventos/ic_battery.png'">
                                    <img v-if="item.evento === 'AUTO_TESTE'" :src="'img/eventos/ic_auto_teste.png'">
                                    <img v-if="item.evento === 'PANIC'" :src="'img/eventos/ic_event.png'">
                                    <img v-if="item.evento === 'FAIL'" :src="'img/eventos/ic_fail.png'">
                                    <img v-if="item.evento === 'NORMALIZATION'" :src="'img/eventos/ic_nomalization.png'">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="item.descricao"/>
                                    <v-list-tile-sub-title v-html="item.detalhe"/>
                                    <v-list-tile-sub-title>[ {{item.canal}} ] - {{item.data_transmissao}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </div>

                    </template>
                </v-list>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import { Eventos } from "../class/eventos";
    import { Ordens } from "../class/ordens";

    export default {
        name: "eventos",
        data () {
            return {
                items: [],
                ordem: null,
                id_transmissao: 0,
                watchID: null
            };
        },
        beforeMount () {
            Ordens
                .get(parseInt(this.$route.params.id))
                .then((ordem) => {
                    if (ordem) {
                        this.ordem = ordem;
                        this.lasts();
                    } else {
                        this.goBack();
                    }
                });
        },
        beforeDestroy () {
            if (this.watchID) {
                clearInterval(this.watchID);
            }
        },
        methods: {
            goBack: function () {
                this.$router.push("/ver-ordem/" + this.$route.params.id);
            },
            lasts: async function () {
                try {
                    let items = await Eventos.lasts(this.ordem.id_contratos_servicos);
                    this.items = items.data.transmissoes;
                    this.count();
                    this.watchID = setInterval(() => this.apos(), 20000);
                } catch (err) {
                    console.log(err);
                }
            },
            count () {
                for (let i of this.items) {
                    if (i.id_transmissao > this.id_transmissao) {
                        this.id_transmissao = i.id_transmissao;
                    }
                }
            },
            async apos () {
                try {
                    let items = await Eventos.lastsApos(this.ordem.id_contratos_servicos, this.id_transmissao);
                    for (let i of items.data.transmissoes) {
                        this.items.unshift(i);
                    }
                    this.count();
                } catch (e) {}
            }
        }
    };
</script>

<style scoped>

</style>
